import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getTestimonials, removeTestimonial } from 'slice/testimonialSlice';
import AdminTable from 'common/AdminTable';
import { getUploadUrl } from 'utils/uploadUrl';
import TruncatedMessage from 'common/TruncatedMessage';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const List = () => {
    const dispatch = useDispatch();
    const { data: testimonials, loading } = useSelector((state) => state.testimonial);

    useEffect(() => {
        dispatch(getTestimonials());
    }, [dispatch]);

    const getImageUrl = (img) => {
        return getUploadUrl(img);
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e67e22',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeTestimonial(id));
            }
        });
    };

    const tableHeaders = [
        { Header: 'ID', accessor: 'id' },
        {
            Header: 'Photo',
            accessor: 'clientPhoto',
            Cell: ({ row }) => (
                <img
                    src={getImageUrl(row.original.clientPhoto)}
                    alt={row.original.clientName}
                    width={50}
                    height={50}
                    style={{ objectFit: 'cover', borderRadius: '50%' }}
                />
            ),
        },
        { Header: 'Client Name', accessor: 'clientName' },
        {
            Header: 'Description',
            accessor: 'description',
            Cell: ({ row }) => <TruncatedMessage text={row.original.description} maxLength={50} />,
        },
        { Header: 'Date', accessor: 'testimonialDate' },
        { Header: 'Rating', accessor: 'rating' },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ row }) => (
                <span className={`badge ${row.original.status === 1 ? 'badge-success' : 'badge-danger'}`}>
                    {row.original.status === 1 ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button className="btn removebtn mx-1" onClick={() => handleDelete(row.original.id)}>
                        Remove
                    </button>
                    <Link to={`/khajuraho/testimonials/update/${row.original.id}`} className="btn editbtn mx-1">
                        Edit
                    </Link>
                </>
            ),
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4 d-flex justify-content-between align-items-center">
                <h4 className="text-white font-weight-bold">Client Testimonials</h4>
                <Link to="/khajuraho/testimonials/add" className="btn btn-light btn-sm font-weight-bold">
                    Add Testimonial
                </Link>
            </div>
            <div className="mt-4">
                {loading ? (
                    <div className="text-center text-white">Loading...</div>
                ) : (
                    testimonials?.length > 0 ? (
                        <AdminTable tableHeaders={tableHeaders} tableData={testimonials} />
                    ) : (
                        <div className="text-center text-white">No testimonials found.</div>
                    )
                )}
            </div>
        </div>
    );
};

export default List;
